import selectSettings from './selectSettings';

const selectGlobalSettings = (state, integration) => selectSettings(state).global;

export default selectGlobalSettings;
